import { Component, HostBinding, Input } from '@angular/core';
import { SmsSegment, smsSegments } from '../../../../utils/sms';

/**
 * Message copy as the recipient will read it, with personalisation fields
 * such as {{firstName}} shown as labelled chips instead of raw braces.
 * `inline` keeps it on one line for table previews; `raw` shows the copy
 * exactly as written, for text that is already final.
 */
@Component({
  selector: 'bk-sms-text',
  standalone: true,
  template: `@if (raw) {<ng-container>{{ copy }}</ng-container>} @else {@for (segment of segments; track $index) {@if (segment.field) {<span class="field" [attr.title]="segment.text">{{ segment.field }}</span>} @else {<ng-container>{{ segment.text }}</ng-container>}}}`,
  styles: `
    :host {
      white-space: pre-line;
      overflow-wrap: anywhere;
    }

    :host(.is-inline) {
      white-space: nowrap;
    }

    .field {
      display: inline-block;
      padding: 0 0.42em;
      border: 1px dashed color-mix(in srgb, currentColor 45%, transparent);
      border-radius: 0.45em;
      font-size: 0.86em;
      line-height: 1.45;
      vertical-align: 0.06em;
      white-space: nowrap;
    }
  `,
})
export class SmsTextComponent {
  copy = '';
  segments: SmsSegment[] = [];

  /** Show any {{field}} as the braces it is sent as, not as a chip: the copy is final. */
  @Input() raw = false;

  @HostBinding('class.is-inline')
  @Input()
  inline = false;

  @Input() set text(value: string | null | undefined) {
    this.copy = value ?? '';
    this.segments = smsSegments(value);
  }
}
